// Generated by purs version 0.14.3
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Error = require("../Data.Argonaut.Decode.Error/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_CommutativeRing = require("../Data.CommutativeRing/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Ring_Module = require("../Data.Ring.Module/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var Algebra = function (LeftModule2, RightModule3, Ring0, Ring1, embed) {
    this.LeftModule2 = LeftModule2;
    this.RightModule3 = RightModule3;
    this.Ring0 = Ring0;
    this.Ring1 = Ring1;
    this.embed = embed;
};
var unsafeToInt = function ($5) {
    return Data_Int.floor($foreign.toNumber($5));
};
var showBigNumber = new Data_Show.Show($foreign.toString(Data_Int.decimal));
var parseBigNumber = $foreign.fromStringAsImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
var eqBigNumber = new Data_Eq.Eq($foreign["_eqBigNumber"]);
var ordBigNumber = new Data_Ord.Ord(function () {
    return eqBigNumber;
}, function (bn1) {
    return function (bn2) {
        var n = $foreign.comparedTo(bn1)(bn2);
        if (n === 0) {
            return Data_Ordering.EQ.value;
        };
        if (n === 1) {
            return Data_Ordering.GT.value;
        };
        return Data_Ordering.LT.value;
    };
});
var embedInt = $foreign["_intToBigNumber"];
var semiringBigNumber = new Data_Semiring.Semiring($foreign["_addBigNumber"], $foreign["_mulBigNumber"], embedInt(1), embedInt(0));
var ringBigNumber = new Data_Ring.Ring(function () {
    return semiringBigNumber;
}, $foreign["_subBigNumber"]);
var embed = function (dict) {
    return dict.embed;
};
var commutativeRingBigNumber = new Data_CommutativeRing.CommutativeRing(function () {
    return ringBigNumber;
});
var euclidianRingBigNumber = new Data_EuclideanRing.EuclideanRing(function () {
    return commutativeRingBigNumber;
}, function (v) {
    return 1;
}, $foreign["_divBigNumber"], $foreign["_modBigNumber"]);
var bigNumberRModule = new Data_Ring_Module.RightModule(function () {
    return Data_Ring.ringInt;
}, Data_Semiring.add(semiringBigNumber), function (a) {
    return function (b) {
        return Data_Semiring.mul(semiringBigNumber)(a)(embedInt(b));
    };
}, Data_Ring.sub(ringBigNumber), embedInt(0));
var bigNumberLModule = new Data_Ring_Module.LeftModule(function () {
    return Data_Ring.ringInt;
}, Data_Semiring.add(semiringBigNumber), function (a) {
    return function (b) {
        return Data_Semiring.mul(semiringBigNumber)(embedInt(a))(b);
    };
}, Data_Ring.sub(ringBigNumber), embedInt(0));
var embedInt$prime = new Algebra(function () {
    return bigNumberLModule;
}, function () {
    return bigNumberRModule;
}, function () {
    return Data_Ring.ringInt;
}, function () {
    return ringBigNumber;
}, embedInt);
var _encode = (function () {
    var $6 = Data_Semigroup.append(Data_Semigroup.semigroupString)("0x");
    var $7 = $foreign.toString(Data_Int.hexadecimal);
    return function ($8) {
        return $6($7($8));
    };
})();
var encodeBigNumber = new Foreign_Generic_Class.Encode((function () {
    var $9 = Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
    return function ($10) {
        return $9(_encode($10));
    };
})());
var writeFBigNumber = new Simple_JSON.WriteForeign(Foreign_Generic_Class.encode(encodeBigNumber));
var encodeJsonBigNumber = new Data_Argonaut_Encode_Class.EncodeJson((function () {
    var $11 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
    return function ($12) {
        return $11(_encode($12));
    };
})());
var _decode = function (str) {
    var v = parseBigNumber(Data_Int.hexadecimal)(str);
    if (v instanceof Data_Maybe.Nothing) {
        return Data_Either.Left.create("Failed to parse as BigNumber: " + str);
    };
    if (v instanceof Data_Maybe.Just) {
        return new Data_Either.Right(v.value0);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Core.BigNumber (line 137, column 15 - line 139, column 20): " + [ v.constructor.name ]);
};
var decodeBigNumber = new Foreign_Generic_Class.Decode(function (x) {
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readString(Data_Identity.monadIdentity)(x))(function (str) {
        return Data_Either.either((function () {
            var $13 = Foreign.fail(Data_Identity.monadIdentity);
            return function ($14) {
                return $13(Foreign.ForeignError.create($14));
            };
        })())(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)))(_decode(str));
    });
});
var readFBigNumber = new Simple_JSON.ReadForeign(Foreign_Generic_Class.decode(decodeBigNumber));
var decodeJsonBigNumber = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonString)(json))(function (str) {
        return Data_Either.either(Data_Function["const"](Data_Either.Left.create(new Data_Argonaut_Decode_Error.UnexpectedValue(json))))(Data_Either.Right.create)(_decode(str));
    });
});
module.exports = {
    Algebra: Algebra,
    embed: embed,
    parseBigNumber: parseBigNumber,
    unsafeToInt: unsafeToInt,
    showBigNumber: showBigNumber,
    eqBigNumber: eqBigNumber,
    ordBigNumber: ordBigNumber,
    semiringBigNumber: semiringBigNumber,
    ringBigNumber: ringBigNumber,
    commutativeRingBigNumber: commutativeRingBigNumber,
    euclidianRingBigNumber: euclidianRingBigNumber,
    bigNumberLModule: bigNumberLModule,
    bigNumberRModule: bigNumberRModule,
    "embedInt'": embedInt$prime,
    decodeBigNumber: decodeBigNumber,
    readFBigNumber: readFBigNumber,
    writeFBigNumber: writeFBigNumber,
    encodeBigNumber: encodeBigNumber,
    decodeJsonBigNumber: decodeJsonBigNumber,
    encodeJsonBigNumber: encodeJsonBigNumber,
    pow: $foreign.pow,
    toString: $foreign.toString,
    toTwosComplement: $foreign.toTwosComplement,
    floorBigNumber: $foreign.floorBigNumber,
    divide: $foreign.divide,
    binary: Data_Int.binary,
    decimal: Data_Int.decimal,
    floor: Data_Int.floor,
    hexadecimal: Data_Int.hexadecimal
};
